import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('container').set({
        label: 'Container',
        category: blockCategories.layout,
        content: {
            type: 'container',
            classes: ['container', 'mx-auto'],
        },
        media: `
           <svg viewBox="0 0 24 24">
                <path fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"></path>
           </svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('container', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Container',
                tagName: 'div',
                droppable: true,
            }),
        },
        isComponent(el) {
            if (el && el.classList && el.classList.contains('container')) {
                return { type: 'container' };
            }
        },
        view: defaultView,
    });
};
